import isEqual from "lodash.isequal";

import { PutExperienceRequestBodyType } from "@intelligems/ig-types";
import { createSelector } from "@reduxjs/toolkit";

import {
  getPutExperiencePayload,
  getPutStoredExperiencePayload,
} from "./payload/getPutExperiencePayload";
import { hasUnsavedProducts } from "./products/hasUnsavedProducts";

export const hasUnsavedExperience = createSelector(
  getPutExperiencePayload,
  getPutStoredExperiencePayload,
  hasUnsavedProducts,
  (current, stored, unsavedProducts) => {
    const normalized = normalizePayload(current);
    const normalizedStored = normalizePayload(stored);
    return !isEqual(normalized, normalizedStored) || unsavedProducts;
  }
);

function normalizePayload(payload: PutExperienceRequestBodyType | undefined) {
  if (!payload) return undefined;
  return {
    ...payload,
    experience: {
      ...payload.experience,
      productVariantCount: 0,
    },
  };
}
